import type { AudioPlayerMenuAction } from "../../types/audio-player";

import { CirclePlus, ClipboardPlus, UserRoundPlus } from "lucide-react";

type AudioPlayerMenuIconProps = {
  icon: AudioPlayerMenuAction["icon"];
};

function SpotifyIcon() {
  return (
    <svg
      aria-hidden="true"
      className="size-6 shrink-0"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" />
      <path
        className="group-hover:stroke-[#f6ffe3] group-focus-visible:stroke-[#f6ffe3]"
        d="M7.5 10.25c3.1-.9 6.7-.55 9 .6M8.25 13c2.55-.65 5.4-.35 7.35.55M9.2 15.5c1.75-.4 3.75-.18 5.15.38"
        fill="none"
        stroke="#2c4f26"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </svg>
  );
}

function AudioPlayerMenuIcon({ icon }: AudioPlayerMenuIconProps) {
  if (icon === "spotify") {
    return <SpotifyIcon />;
  }

  if (icon === "follow") {
    return <UserRoundPlus aria-hidden="true" className="size-6 shrink-0" />;
  }

  if (icon === "external") {
    return <CirclePlus aria-hidden="true" className="size-6 shrink-0" />;
  }

  return <ClipboardPlus aria-hidden="true" className="size-6 shrink-0" />;
}

export { AudioPlayerMenuIcon };
